var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-invest-wrapper"
  }, [_c('div', {
    staticClass: " main-invest-container-wrapper "
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }), _c('div', {
    staticClass: "main-invest-container"
  }, [_c('h1', {
    staticClass: "enter-title"
  }, [_vm._v("Инвестиции")]), _vm._m(0), _vm.step === 1 ? [_vm.isMail ? _c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход в почту")]) : _c('div', {
    staticClass: "enter-caption"
  }, [_c('p', [_vm._v("Вход / ")]), _c('p', [_vm._v("регистрация ")])]), _c('div', {
    attrs: {
      "id": "payment-form"
    }
  }), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error,
      'input-containers-error-agreement': _vm.error && _vm.error.type === 'agreement'
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Ваш телефон")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "tel",
      "placeholder": "+7 999 123 45 67",
      "id": "phone"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.error.message
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1), _vm.isMail ? _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Вернуться на главную")])]) : _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Вернуться назад")])])])])] : _vm._e(), _vm.step === 2 ? [_c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.password,
      expression: "password"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "relative mt-30px"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.passwordConfirm,
      expression: "passwordConfirm"
    }],
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "password",
      "placeholder": "Пароль еще раз"
    },
    domProps: {
      "value": _vm.passwordConfirm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.error.message || 'Зарегистрироваться'
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])]), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 1;
      }
    }
  }, [_vm._v("Вернуться назад")])])] : _vm._e(), _vm.step === 3 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход / ")]), _c('div', {
    attrs: {
      "id": "payment-form"
    }
  }), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "_off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(" Введите пароль для входа")]), _c('div', {
    staticClass: "input-group"
  }, [_c('InputHideShow', {
    attrs: {
      "hasError": _vm.error
    },
    on: {
      "setPass": _vm.setPass
    }
  })], 1), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.error.message || 'Войти'
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 4;
      }
    }
  }, [_vm._v("Забыл пароль")])])])])] : _vm._e(), _vm.step === 4 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Восстановление доступа /")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(" Код из SMS")]), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '####',
      expression: "'####'"
    }],
    key: "code",
    staticClass: "text-input",
    class: {
      'text-input-error': _vm.error.message
    },
    attrs: {
      "type": "text",
      "placeholder": "Введите код из SMS"
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('ButtonAction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length !== 4,
      expression: "code.length !== 4"
    }],
    staticClass: "main-action-btn",
    class: {
      'main-action-btn-disabled': _vm.codeSubmitDisabled
    },
    attrs: {
      "type": "submit",
      "message": _vm.codeSubmitButton,
      "isDisabled": _vm.codeSubmitDisabled
    },
    on: {
      "buttonAction": _vm.sendCode
    }
  }), _c('ButtonAction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length === 4,
      expression: "code.length === 4"
    }],
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.error.message
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)])])] : _vm._e(), _vm.step === 5 ? [_c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Восстановление доступа /")]), _c('form', {
    staticClass: "enter-form",
    attrs: {
      "method": "post",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "input-containers confirm",
    class: {
      'input-containers-error': _vm.error
    }
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm.error && _vm.password !== _vm.passwordConfirm ? _c('span', [_vm._v("Пароли не совпадают")]) : _vm.error && (_vm.password.length < 6 || _vm.passwordConfirm.length < 6) ? _c('span', [_vm._v("Пароль не менее 6 символов")]) : _c('span', [_vm._v("Задайте новый пароль не менее 6 символов")])]), _c('div', {
    staticClass: "input-group-double"
  }, [_c('InputHideShow', {
    attrs: {
      "hasError": _vm.error
    },
    on: {
      "setPass": _vm.setPass
    }
  })], 1), _c('div', {
    staticClass: "input-group-double"
  }, [_c('InputHideShow', {
    attrs: {
      "hasError": _vm.error
    },
    on: {
      "setPass": _vm.setPassConfirm
    }
  })], 1), _c('div', {
    staticClass: "input-group button-group"
  }, [_c('input', {
    staticClass: "button blue",
    class: {
      'btn-error': _vm.error.message
    },
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.error.message || 'Войти'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event);
      }
    }
  })]), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 3;
      }
    }
  }, [_vm._v("Вернуться назад")])])])])] : _vm._e()], 2), _c('div', {
    staticClass: "footer-wrapper"
  }, [_c('FooterAgreement', {
    on: {
      "setAgree": _vm.isAgree
    }
  }), _c('div', {
    staticClass: "notpersonal-advice"
  }, [_vm._v(" *Любые сведения, указанные в Статьях, носят исключительно рекомендательный характер и нацелены на оказание помощи Пользователям Сервиса в получении необходимой справочной информации. Администрация Сервиса не несет ответственности за убыток или ущерб, включая, в частности, любую утрату выгоды, которая может являться прямым или косвенным результатом использования или принятия во внимание такой информации. Не является индивидуальной инвестиционной рекомендацией. ")])], 1)], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', {
    staticClass: "enter-sub-title"
  }, [_vm._v("Откройте мир фондовых рынков "), _c('br'), _vm._v("по-новому: как, куда и зачем вложить свои средства. ")]);
}]

export { render, staticRenderFns }